module.exports = __webpack_public_path__ + "img/btn_bg.f61ae6b8.png";